import { render } from "./Medico_Agenda.vue?vue&type=template&id=6a8728bc&scoped=true"
import script from "./Medico_Agenda.vue?vue&type=script&lang=js"
export * from "./Medico_Agenda.vue?vue&type=script&lang=js"

import "./Medico_Agenda.vue?vue&type=style&index=0&id=6a8728bc&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8728bc"]])

export default __exports__